/**
 * IANA timezone from the user's browser (e.g. Europe/Madrid).
 */
export function getBrowserIanaTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
}
